var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"metric-card"},[_c('a-statistic',{attrs:{"title":_vm.title,"value":_vm.value}}),_c('div',{staticClass:"byline"},[_vm._v(" "+_vm._s(_vm.metric.byline)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }